import * as types from './types'

export function requestFeeds(name){
  return{
    type: types.REQUEST_FEEDS,
    name,
    [`${name}IsFetching`]: true,
    [`${name}IsRejected`]: false,
  }
}

export function receiveFeeds(items, name, homepage){
  // sending dynamic keyhash variables to dispatch actions to reducers
  return{
    type: types.RECEIVE_FEEDS,
    name,
    [`${name}Homepage`]: homepage,
    [`${name}IsFetching`]: false,
    [`${name}IsRejected`]: false,
    [`${name}Items`]: items
  }
}

export function rejectFeeds(err, name){
  return{
    type: types.REJECT_FEEDS,
    [`${name}IsFetching`]: false,
    [`${name}IsRejected`]: true,
    [`${name}Items`]: [],
    errorMessage: err
  }
}